import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { appRoutes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { authInterceptor, httpErrorInterceptor, provideAuth } from '@angular-monorepo/auth';
import { API_URL, GlobalErrorHandler } from '@angular-monorepo/data-access';
import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';
import { ConfigService } from '../environments/environment.service';
import { MediveliusPreset } from '../theme/medivelius-preset';
import { usersAssignRolesInterceptor } from './interceptors/users-assign-roles.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export function createTranslateLoader(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export const MediveliusAppConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MediveliusPreset,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark',
          cssLayer: false,
        },
      },
    }),
    provideAuth(),
    provideHttpClient(
      withInterceptors([
        usersAssignRolesInterceptor, // Traduce la edicion de rol a POST /assign-roles (sin tocar libs)
        authInterceptor,
        httpErrorInterceptor,
      ]),
    ),

    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },

    MessageService,
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),

    {
      provide: 'AUTH_CONFIG',
      useValue: {
        apiUrl: environment.apiUrl,
        loginEndpoint: '/api/auth/login/',
      },
    },
    {
      provide: API_URL,
      useFactory: (configService: ConfigService) => configService.getApiUrl(),
      deps: [ConfigService],
    },
  ],
};
